import { MenuItemInterface } from './Menu';
import {
    LinkGeneralInterface,
    LinkInterface,
} from 'components/interfaces/GeneralInterface';

export const getActiveLink = (
    links: LinkGeneralInterface[],
    currentRoutePath: string
): LinkInterface => {
    const innerLinks: LinkInterface[] = [];
    links.forEach((link) => {
        innerLinks.push({
            idx: link.idx,
            link: link.link,
            blankPage: link.blankPage,
            text: link.text,
        });

        link.items?.forEach((item) => innerLinks.push(item));
    });

    const linksWithCommonBase = innerLinks.filter((l) => {
        const linkNoDiscipline = l.link ? l.link.split('?')[0] : l.link;
        // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(`^${linkNoDiscipline}`);
        return regex.test(currentRoutePath);
    });
    return linksWithCommonBase.sort((a, b) =>
        a.link.length > b.link.length ? -1 : 1
    )[0];
};

export const getActiveItem = (
    items: MenuItemInterface[],
    pseudoPathName: string
): MenuItemInterface => {
    const matches = items.filter(({ link, configKey }) => {
        // Položky bez configKey nejsou nikdy aktivní (např. dynamické externí linky)
        if (!configKey) {
            return false;
        }
        // Pokud je link externí (začíná http:// nebo https://), nikdy není aktivní
        if (
            link &&
            (link.startsWith('http://') || link.startsWith('https://'))
        ) {
            return false;
        }
        return pseudoPathName.startsWith(
            link ? link.split('?')[0] + '/' : link
        );
    });
    // Nejvíce specifická shoda (nejdelší link) vyhrává – rozliší např. '/social'
    // (Vytvořit příspěvek) od '/social/connections' (Připojené stránky), které
    // sdílí stejný configKey a obě by jinak prefixem matchovaly na child route.
    return matches.sort(
        (a, b) => (b.link?.length ?? 0) - (a.link?.length ?? 0)
    )[0];
};
